import React, { Suspense } from 'react';
import { TimeLazyLoad } from '../../../common/lazy-load-timing';
import { LoadingSpinner } from '../../../common/loading-spinner';
import { withProductContext } from '../product-router';
import { InitialisationExperienceSuccess } from './initialisation-experience-success';
import { ActiveProduct } from './active-product';
export class AsyncProductInner extends React.Component {
  componentWillUnmount() {
    const {
      removeProduct,
      id
    } = this.props;
    removeProduct(id);
  }
  render() {
    const {
      fallback: FallbackComponent,
      id,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement(ActiveProduct, {
        id: id
      }, /*#__PURE__*/React.createElement(TimeLazyLoad, {
        product: id
      }, FallbackComponent ? /*#__PURE__*/React.createElement(FallbackComponent, null) : /*#__PURE__*/React.createElement(LoadingSpinner, null)))
    }, /*#__PURE__*/React.createElement(InitialisationExperienceSuccess, this.props), children);
  }
}

/**
 * A component to register the product with a product router and asyncronously load its contents
 */
export const AsyncProduct = withProductContext(AsyncProductInner);